import React from "react";
import SEO from "../components/SEO";
import content from "../data/contentData.json";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Hero from "../components/Hero";
import AboutMe from "../components/AboutMe.jsx";
import Services from "../components/Services.jsx";
import PricesTable from "../components/PricesTable.jsx";
import LawyerImage from "../components/LawyerImage.jsx";
import SectionContact from "../components/SectionContact.jsx";
import { useParams } from "react-router-dom";
import Content from "../components/Content.jsx";
import PageRoute from "../components/PageRoute.jsx";
import Contacts from "./Contacts.jsx";
import i18n from "../i18n.js";
import Footer from "../components/Footer.jsx";

export default function Home() {

  const { section } = useParams();
  const data = content.home;
  return (
    <>

      <Hero />
      <AboutMe />
      {/*<Services />*/}
      <Content initialSection={section} />
      <PricesTable />
      <LawyerImage />
      <div className="relative z-10">
        <SectionContact />
      </div>
      <Footer></Footer>

    </>
  );
}
